/** Selectable option for menus / suggestions (API `value` vs UI `title`). */
export interface FieldOptionItem {
  value: string
  title: string
  icon?: string
  data?: unknown
}

/** Schema helper when title equals the API value. */
export function fieldOptions(...values: string[]): FieldOptionItem[] {
  return values.map((value) => ({ value, title: value }))
}
